import React, { useState, useEffect } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      <Link color="inherit" href="https://discord.gg/StalkerZ">
        StalkerZ
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "black",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "black",
  },
  error: {
    color: "red",
  },
}));

export default function SignIn(props) {
  const classes = useStyles();
  const [message, setMessage] = useState("");

  const handleSteamLogin = () => {
    const popup = window.open(
      `${process.env.REACT_APP_API_URL}/api/auth/steam`,
      "steamLogin",
      "width=800,height=600,left=200,top=100"
    );

    if (!popup || popup.closed || typeof popup.closed === "undefined") {
      setMessage("Popup was blocked. Please allow popups for this site and try again.");
      return;
    }

    popup.focus();

    const timer = setInterval(() => {
      if (popup.closed) {
        clearInterval(timer);
        fetch(`${process.env.REACT_APP_API_URL}/api/auth/validate`, { credentials: "include" })
          .then((r) => r.json())
          .then((json) => {
            if (json && json._id) {
              localStorage.setItem("user", JSON.stringify(json));
              props.history.push("/");
              window.location.reload();
            }
          });
      }
    }, 500);
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <form className={classes.form} noValidate>
          <img src="https://i.imgur.com/5dhiJgO.png" alt="StalkerZ" />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={handleSteamLogin}
          >
            Login with Steam
          </Button>
          {message && <span className={classes.error}>{message}</span>}
          <Grid container>
            <Grid item xs>
              Do not contact staff for account issues, authentication is handled through steam. If logging in through steam doesn't work, please try it a few times and you'll eventually get in.
              <p><strong>Use Google Chrome or Microsoft Edge!</strong></p>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}
